import { render, staticRenderFns } from "./IncrementalOnboardingBusinessAddress.vue?vue&type=template&id=cd2656e0&"
import script from "./IncrementalOnboardingBusinessAddress.vue?vue&type=script&lang=js&"
export * from "./IncrementalOnboardingBusinessAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports